import CheckWhiteIcon from "../../../../assets/icons/check-white.svg";
import ReviewField from "../ReviewField";
import SectionDocuments from "../SectionDocuments";
import "./AddressSection.css";

const ADDRESS_COMPARE_KEYS = [
  "house",
  "street",
  "area",
  "landmark",
  "city",
  "state",
  "pincode",
];

const isSameCurrentAndPermanentAddress = (address = {}) => {
  if (address.address_flag === true || address.same_as_current === true) {
    return true;
  }
  if (address.address_flag === false || address.same_as_current === false) {
    return false;
  }

  return ADDRESS_COMPARE_KEYS.every((key) => {
    const current = String(address[`current_address_${key}`] ?? "")
      .trim()
      .toLowerCase();
    const permanent = String(address[`permanent_address_${key}`] ?? "")
      .trim()
      .toLowerCase();
    return current === permanent;
  });
};

const AddressSection = ({
  fields = [],
  formData,
  fieldFlags,
  flagModeEnabled,
  restrictToUpdatedFields,
  updatedFields,
  flagModal,
  focusedFlagKey,
  onOpenFlagModal,
  onUpdateField,
  documents = [],
  getFileIcon,
  onPreviewDoc,
}) => {
  const fieldProps = {
    sectionKey: "address",
    formData,
    fieldFlags,
    flagModeEnabled,
    restrictToUpdatedFields,
    updatedFields,
    flagModal,
    focusedFlagKey,
    onOpenFlagModal,
    onUpdateField,
  };

  const addressesMatch = isSameCurrentAndPermanentAddress(formData?.address);
  const nodes = [];
  for (let index = 0; index < fields.length; index += 1) {
    const field = fields[index];

    if (field?.type === "heading") {
      nodes.push(
        <div
          key={`address-heading-break-${field.label}`}
          className="rr-flex-break"
          aria-hidden="true"
        />,
      );
      nodes.push(
        <div
          key={`address-heading-${field.label}`}
          className={`rr-subsection-head${
            index === 0 ? " rr-subsection-head--first" : ""
          }`}
        >
          <div className="form-subhead">{field.label}</div>
        </div>,
      );
      if (field.label === "Current Address" && addressesMatch) {
        nodes.push(
          <div key="address-same-address" className="rr-same-address-banner">
            <span className="rr-same-address-banner__check" aria-hidden="true">
              <img src={CheckWhiteIcon} alt="" />
            </span>
            <span className="rr-same-address-banner__text">
              Permanent address is the same as current address
            </span>
          </div>,
        );
      }
      continue;
    }

    if (field.rowStart) {
      nodes.push(
        <div
          key={`address-row-${field.key}`}
          className="rr-flex-break"
          aria-hidden="true"
        />,
      );
    }

    nodes.push(
      <ReviewField key={field.key} {...fieldProps} field={field} />,
    );
  }

  return (
    <>
      <div className="flex flex-wrap rr-address-fields">{nodes}</div>
      <SectionDocuments
        sectionKey="address"
        documents={documents}
        getFileIcon={getFileIcon}
        onPreviewDoc={onPreviewDoc}
        fieldFlags={fieldFlags}
        flagModeEnabled={flagModeEnabled}
        restrictToUpdatedFields={restrictToUpdatedFields}
        updatedFields={updatedFields}
        flagModal={flagModal}
        focusedFlagKey={focusedFlagKey}
        onOpenFlagModal={onOpenFlagModal}
      />
    </>
  );
};

export default AddressSection;
